module.exports = __webpack_public_path__ + "img/16.d6e5ec3f.jpg";